const GridVertical = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10H11V14H7V10ZM7 4H11V8H7V4ZM7 16H11V20H7V16ZM13 10H17V14H13V10ZM13 4H17V8H13V4ZM13 16H17V20H13V16Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default GridVertical;
